import type { SVGProps } from "react";
const SvgQuillWrite01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.076 17C4.089 4.545 12.912 1.012 19.973 2.224c.286 4.128-1.734 5.673-5.58 6.387.742.776 2.055 1.753 1.913 2.974-.1.868-.69 1.295-1.87 2.147C11.85 15.6 8.854 16.78 5.076 17"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4 22c0-6.5 3.848-9.818 6.5-12"
    />
  </svg>
);
export default SvgQuillWrite01;
